import { BASE_URL } from '@synergy/config';
import { Hidden, Stack, styled } from '@mui/material';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import { ConfirmUser } from './confirm-user/confirm-user';
import { ForgotPassword } from './forgot-password/forgot-password';
import { ForgotPasswordSuccess } from './forgot-password/forgot-password-success';
import { Login } from './login/login';
import { LoginBanner } from './common/components/banner/login-banner';
import { QuickLoginErrorPage } from './quick-login-error-page/quick-login-error-page';
import { ResetPassword } from './reset-password/reset-password';

const StyledContainer = styled(Stack)(() => ({
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
}));

const Container = styled(Stack)(({ theme }) => ({
    width: '50%',
    height: '100%',
    padding: theme.spacing(9),

    [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(3),
    },
}));

export const App = () => {
    return (
        <StyledContainer>
            <Hidden smDown>
                <LoginBanner />
            </Hidden>
            <Container>
                <Router basename={BASE_URL || '/'}>
                    <Routes>
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/forgot-password/:email" element={<ForgotPasswordSuccess />} />
                        <Route path="/new-password" element={<ResetPassword />} />
                        <Route path="/quick-login-error" element={<QuickLoginErrorPage />} />
                        <Route path="/:userType/confirm-user" element={<ConfirmUser />} />
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="*"
                            element={<Navigate to={{ pathname: '/login', search: window.location.search }} />}
                        />
                    </Routes>
                </Router>
            </Container>
        </StyledContainer>
    );
};
